export const BalanceType = {
  FETCH_CURRENT_BALANCE: "BALANCE::FETCH_CURRENT_BALANCE",
  SET_AMOUNT: "BALANCE::SET_AMOUNT",
};
